const dateUtils = {


    getCurrentDate: (separator = "") => {
        let newDate = new Date();
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();

        return `${year}${separator}${month < 10 ? `0${month}` : month}${separator}${date < 10 ? `0${date}` : date}`;
    },

    isDateBeforeToday: (dateStr, validTime) => {

        const dayFromDate = dateUtils.dayFromDate(dateStr);

        return dayFromDate > validTime;
    },

    dayFromDate: (dateStr) => {
        // Parse the string date into a Date object
        const inputDate = new Date(dateStr);

        // Get the current date
        const currentDate = new Date();

        // Calculate the time difference in milliseconds
        const timeDifference = currentDate - inputDate;

        // Calculate the number of days (milliseconds / 24 hours / 60 minutes / 60 seconds)
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

        console.log(daysDifference);
        return daysDifference;
    },

    getNightCount: (startDate, endDate) => {
        if (!startDate || !endDate) return 0;
        const diff = (endDate - startDate) / (1000 * 60 * 60 * 24);
        return Math.round(diff);
    },

    getFirstExcludedAfter: (startDate, excluded) => {
        if (!excluded || excluded.length === 0) return null;

        const nextDay = new Date(startDate);
        nextDay.setDate(nextDay.getDate() + 1);

        return excluded
          .map((d) => new Date(d))
          .filter((d) => d >= nextDay)
          .sort((a, b) => a - b)[0] || null;
    },



    now: () => {
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = currentDate.getFullYear();
        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}`
    }

};


export default dateUtils;
